module.exports = __webpack_public_path__ + "static/1-4b2521e415018335ba36c069134859a3.png";